<template>
  <div>
    <div class="container">
      <div class="columns">
        <div class="column is-three-fifths is-offset-one-fifth">
          <div class="features">
            <premium-features />
          </div>
          <stripe-pay
            v-if="!subscriptionIsLoading"
            :type="hasSubscription ? 'addCard' : 'addSubscription'"
            :toggle-payment-info="!hasSubscription"
          />
        </div>
      </div>
    </div>
    <b-loading :is-full-page="true" :active="subscriptionIsLoading"></b-loading>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import PremiumFeatures from '@/components/PremiumFeatures.vue'
import StripePay from '@/components/StripePay.vue'

export default {
  name: 'Upgrade',
  components: {
    PremiumFeatures,
    StripePay
  },
  computed: {
    ...mapGetters([
      'hasSubscription',
      'subscriptionIsLoading',
    ]),
  },
};
</script>

<style scoped lang="scss">
.features {
  margin-bottom: 20px;
}
</style>
